class Native {
    constructor() {
        this.doc = document;
        this.body = document.body;
        this.fundBackPreCb = null,
            window.fundBack = this.fundBack.bind(this);
        window.getLoginMsgCb = this.getLoginMsgCb.bind(this);
        this.cb = null,
            this.evaluate = false;
    }

    getRandFuncName(cb) {
        var funcName = `Native_${new Date().getTime()}`
        window[funcName] = cb
        return funcName
    }

    /**
     * 从app从获取用户登陆信息
     * @param {*} _backCbName
     */
    getLoginMsg(cb) {
        this.cb = cb;
        this.addIframeLink(`emfundapp:nativeLogin({"callbackMethodName":"getLoginMsgCb"})`);
    }

    /**
     * 打开一个新的webview
     * @param {String} url 地址
     * @param {Boolean} oldwinrelease 是否销毁前一个页面
     * @param {Boolean} needparam 是否需要拼参数 5.0.0新增
     */
    gonewpage(url, oldwinrelease, needparam) {
        oldwinrelease = oldwinrelease == void 0 ? false : oldwinrelease || false
        needparam = needparam == void 0 ? true : needparam || true
        if (this.isFund()) {
          this.addIframeLink(`emfundapp:gonewpage({"url":"${url}", "oldwinrelease":${oldwinrelease},"needparam": ${needparam}})`);
        } else {
          window.open(url)
        }
    }

    getLoginMsgCb(res) {
        this.cb(res);
        this.cb = null
    }

    /**
     * 设置标题
     * @param {String} _title 标题
     * @param {String} _subTitle 子标题
     * @param {String} _backCbName 返回按钮回调方法名（需要该方法在全局作用域下）
     */
    setTitle(_title, _subTitle, _backCbName) {
        if (_title === void 0) { _title = '人工客服'; }
        this.doc.title = _title;
        this.addIframeLink(`emfundapp:headerInfo({"backevent": "${_backCbName ? _backCbName : 'fundBack'}", "title": "${_title}", "callbackMethodName": "", "subtitle": "${_subTitle || ""}", "name": "", "event": "", "vifylogin": "" })`);
    }
    setRobotTitle() { this.setTitle("在线客服", '') } /* 设置机器人标题 */

    /**
     * 判断设备类型
     */
    isios() { return /(iPhone|iPod|iPad|iTouch|iOS)/i.test(navigator.userAgent); }
    isAndroid() { return /android/i.test(navigator.userAgent); }
    isMobile() { return this.isios() || this.isAndroid(); }
    isEm() { return /eastmoney/i.test(self.navigator.userAgent); }
    isFund() { return /ttjj/i.test(self.navigator.userAgent); }
    getDeviceType() { return this.isAndroid() ? "android" : this.isios() ? "ios" : "pc" };

    setEvaluate(status) {
        this.evaluate = !!status;
    }

    setFundBackPreCb(cb) {
        this.fundBackPreCb = cb
    }

    fundBack() {
        var self = this;
        if (self.fundBackPreCb) {
            self.fundBackPreCb();
            return;
        }
        if (self.evaluate) {
            Bus.$emit("triggerFeedActionsheet", () => {
                self.addIframeLink("emfundapp:backPreviousPage");
            }, true)
        } else {
            self.addIframeLink("emfundapp:backPreviousPage");
        }
    }

    nativeFeedBack() {
        this.addIframeLink(`emfundapp:ttjj-feedback`);
    }

    /**
     * 调用短链
     * @param {String} link 链接地址
     */
    addIframeLink(link) {
        if (!this.isFund()) return; // 非基金app禁止调用

        var iframe = this.doc.createElement("iframe");
        iframe.style.display = 'none';
        iframe.src = link;
        iframe.onload = function() {
            this.body.removeChild(iframe);
        }
        this.body.appendChild(iframe)
    }
}

export default new Native();



// WEBPACK FOOTER //
// ./src/utils/Native.js